import React from "react";
import { InlineMath } from "react-katex";
import { makeSimpleClosedTask, normalizeMay2026Variant } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
import { getProjectileData } from "./MaturaMay2026ProjectileData";

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const data = getProjectileData(variant === "original");
  const answer = `t=${String(data.ground).replace(".","{,}")}\\text{ s}`;
  return makeSimpleClosedTask({
    type: "MaturaProjectileGroundTimeClosedTask",
    taskNumber: "33.1",
    variant,
    prompt: <span>Wysokość piłeczki opisuje funkcja <InlineMath math={`h(t)=${String(data.a).replace(".","{,}")}t^2+${String(data.b).replace(".","{,}")}t`}/>. Po raz pierwszy po wyrzuceniu uderzy w ziemię w chwili:</span>,
    correct: answer,
    wrong: [`t=${data.ground+1}\\text{ s}`, `t=${Math.max(.5,data.ground-.5)}\\text{ s}`, `t=${data.ground+.5}\\text{ s}`],
    tags: ["funkcja kwadratowa", "zastosowania"],
    explanationSteps: [
      { title: <>Przyrównujemy wysokość do zera i wyłączamy <InlineMath math="t" /> przed nawias.</>, latex: `t(${data.a}t+${data.b})=0\\Longrightarrow t=0\\;\\lor\\;t=${data.ground}` },
      { title: "Odrzucamy chwilę wyrzutu.", latex: answer },
    ],
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
